module.exports = __webpack_public_path__ + "static/img/plantavida.5b1f92f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plantavida.png
// module id = /onR
// module chunks = 1